const ConfigurationMixin = {
  methods: {
    createConfiguration(configuration) {
      const url = route("public.api.configurations.store");

      return axios.post(url, configuration);
    },

    getConfiguration(id, locale) {
      const url = route("public.api.configurations.show", {
        configuration: id,
        locale: locale,
      });

      return axios.get(url);
    },

    getConfigurationPrintUrl(configuration) {
      return configuration
        ? route("configuration.print", {
            company: configuration.company.slug,
            configuration: configuration.id,
          })
        : null;
    },

    getConfigurations() {
      const url = route("public.api.configurations.index");

      return axios.get(url);
    },
  },
};

export default ConfigurationMixin;
